import { render, staticRenderFns } from "./ComplaintEmisorAnnexes.vue?vue&type=template&id=6dfc2896"
import script from "./ComplaintEmisorAnnexes.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorAnnexes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports